import api from '../api/axios';

export interface Project {
  id?: number;
  projectName: string;
  projectCode: string;
  description?: string;
  client?: number;
  startDate?: string;
  endDate?: string;
  budget?: number;
  actualCost?: number;
  status?: 'planning' | 'active' | 'onHold' | 'completed' | 'cancelled';
  manager: number;
  priority?: 'low' | 'medium' | 'high';
  progress?: number;
}

const ProjectService = {
  getAll: (params?: any) => api.get('/projects', { params }),
  getOne: (id: number) => api.get(`/projects/${id}`, { params: { populate: '*' } }),
  create: (data: Project) => api.post('/projects', { data }),
  update: (id: number, data: Partial<Project>) => api.put(`/projects/${id}`, { data }),
  delete: (id: number) => api.delete(`/projects/${id}`),
};

export default ProjectService;

